const isotretinoinDrugList = ["isotretinoin"];

export default isotretinoinDrugList;
